import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $FlagImageOption = styled.img`
  display: inline-block;
  max-width: ${spacing(3.5)};
  margin-right: ${spacing('sm')};
`;

export const $FlagImageValue = styled.img`
  display: inline-block;
  max-width: ${spacing(3.5)};
  margin-right: ${spacing(1.5)};
  margin-bottom: ${-spacing('px')};
`;

export const $DisplayValue = styled.div`
  margin-right: ${spacing(3.5)};
  display: flex;
`;
